import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { IndeedFlexProvider } from '../context/IndeedFlexProvider'
import { IndeedFlexShiftActionsProvider } from '../shared/context/IndeedFlexShiftActionsProvider'
import { IndeedFlexJobShiftsProvider } from './context/IndeedFlexJobShiftsProvider'
import { IndeedFlexJobShiftsMain } from './components/IndeedFlexJobShiftsMain'

export const IndeedFlexJobShifts = () => {
  return (
    <NuqsAdapter>
      <IndeedFlexProvider>
        <IndeedFlexShiftActionsProvider>
          <IndeedFlexJobShiftsProvider>
            <IndeedFlexJobShiftsMain />
          </IndeedFlexJobShiftsProvider>
        </IndeedFlexShiftActionsProvider>
      </IndeedFlexProvider>
    </NuqsAdapter>
  )
}
